import axios from "axios";
import { getToken } from "../../../auth/authService";

const api = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + "/admin/daily-sentences",
  headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
  const token = getToken();
  console.log("[AdminDailySentence] Bearer token present:", !!token);
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  } else {
    console.warn("[AdminDailySentence] No token found, request may fail with 401");
  }
  return config;
});

// ===== CATEGORIES =====
export const fetchCategories = async (params = {}) => {
  try {
    const cleaned = Object.fromEntries(Object.entries(params).filter(([, v]) => v !== "" && v != null));
    console.log("[AdminDailySentence] Fetching categories, params:", cleaned);
    const res = await api.get("/categories", { params: cleaned });
    console.log("[AdminDailySentence] Categories response:", res.status, res.data);
    return { status: res.status, data: res.data };
  } catch (err) {
    console.error("[AdminDailySentence] Categories failed:", err.response?.status, err.response?.data);
    return { status: err.response?.status || 500, message: err.response?.data?.message || "Failed to fetch categories" };
  }
};

export const createCategory = async (data) => {
  try {
    console.log("[AdminDailySentence] Creating category:", data);
    const res = await api.post("/categories", data);
    console.log("[AdminDailySentence] Create category response:", res.status, res.data);
    return { status: res.status, data: res.data };
  } catch (err) {
    console.error("[AdminDailySentence] Create category failed:", err.response?.status, err.response?.data);
    return { status: err.response?.status || 500, message: err.response?.data?.message || "Create failed" };
  }
};

export const updateCategory = async (id, data) => {
  try {
    console.log("[AdminDailySentence] Updating category id:", id, "data:", data);
    const res = await api.put(`/categories/${id}`, data);
    console.log("[AdminDailySentence] Update category response:", res.status, res.data);
    return { status: res.status, data: res.data };
  } catch (err) {
    console.error("[AdminDailySentence] Update category failed:", id, err.response?.status, err.response?.data);
    return { status: err.response?.status || 500, message: err.response?.data?.message || "Update failed" };
  }
};

export const deleteCategory = async (id) => {
  try {
    console.log("[AdminDailySentence] Deleting category id:", id);
    const res = await api.delete(`/categories/${id}`);
    console.log("[AdminDailySentence] Delete category response:", res.status);
    return { status: res.status };
  } catch (err) {
    console.error("[AdminDailySentence] Delete category failed:", id, err.response?.status, err.response?.data);
    return { status: err.response?.status || 500, message: err.response?.data?.error || err.response?.data?.message || "Delete failed" };
  }
};

export const fetchCategoryById = async (id) => {
  try {
    console.log("[AdminDailySentence] Fetching category by id:", id);
    const res = await api.get(`/categories/${id}`);
    console.log("[AdminDailySentence] Fetch category by id response:", res.status, res.data);
    return { status: res.status, data: res.data };
  } catch (err) {
    console.error("[AdminDailySentence] Fetch category by id failed:", id, err.response?.status, err.response?.data);
    return { status: err.response?.status || 500, message: err.response?.data?.message || "Failed to fetch" };
  }
};

// ===== OPTIONS =====
export const fetchSentenceOptions = async () => {
  try {
    console.log("[AdminDailySentence] Fetching options");
    const res = await api.get("/options");
    console.log("[AdminDailySentence] Options response:", res.status, res.data);
    return { status: res.status, data: res.data };
  } catch (err) {
    console.error("[AdminDailySentence] Options failed:", err.response?.status, err.response?.data);
    return { status: err.response?.status || 500, message: err.response?.data?.message || "Failed to fetch options" };
  }
};

// ===== SENTENCES =====
export const fetchDailySentences = async (params) => {
  try {
    console.log("[AdminDailySentence] Fetching all sentences, params:", params);
    const res = await api.get("", { params });
    console.log("[AdminDailySentence] Fetch all response:", res.status, res.data);
    return { status: res.status, data: res.data };
  } catch (err) {
    console.error("[AdminDailySentence] Fetch all failed:", err.response?.status, err.response?.data);
    return { status: err.response?.status || 500, message: err.response?.data?.message || "Failed to fetch" };
  }
};

export const fetchDailySentenceById = async (id) => {
  try {
    console.log("[AdminDailySentence] Fetching sentence by id:", id);
    const res = await api.get(`/${id}`);
    console.log("[AdminDailySentence] Fetch by id response:", res.status, res.data);
    return { status: res.status, data: res.data };
  } catch (err) {
    console.error("[AdminDailySentence] Fetch by id failed:", id, err.response?.status, err.response?.data);
    return { status: err.response?.status || 500, message: err.response?.data?.message || "Failed to fetch" };
  }
};

export const createDailySentence = async (data) => {
  try {
    console.log("[AdminDailySentence] Creating sentence:", data);
    const res = await api.post("", data);
    console.log("[AdminDailySentence] Create response:", res.status, res.data);
    return { status: res.status, data: res.data };
  } catch (err) {
    console.error("[AdminDailySentence] Create failed:", err.response?.status, err.response?.data);
    return { status: err.response?.status || 500, message: err.response?.data?.message || "Create failed" };
  }
};

export const updateDailySentence = async (id, data) => {
  try {
    console.log("[AdminDailySentence] Updating sentence id:", id, "data:", data);
    const res = await api.put(`/${id}`, data);
    console.log("[AdminDailySentence] Update response:", res.status, res.data);
    return { status: res.status, data: res.data };
  } catch (err) {
    console.error("[AdminDailySentence] Update failed:", id, err.response?.status, err.response?.data);
    return { status: err.response?.status || 500, message: err.response?.data?.message || "Update failed" };
  }
};

export const deleteDailySentence = async (id) => {
  try {
    console.log("[AdminDailySentence] Deleting sentence id:", id);
    const res = await api.delete(`/${id}`);
    console.log("[AdminDailySentence] Delete response:", res.status);
    return { status: res.status };
  } catch (err) {
    console.error("[AdminDailySentence] Delete failed:", id, err.response?.status, err.response?.data);
    return { status: err.response?.status || 500, message: err.response?.data?.message || "Delete failed" };
  }
};
